import classNames from 'classnames';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

interface IconButtonProps {
  onClick: () => void;
  active?: boolean;

  btnClassName?: string;

  isDisabled?: boolean;
  icon: string;

  tooltip?: string;
  e2e?: string;
}

export const IconButton = forwardRef(
  (
    { btnClassName, onClick, icon, active, e2e, isDisabled, tooltip }: IconButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <button
        className={classNames('btn btn-lg btn-icon', btnClassName ?? 'btn-flat-secondary', {
          active: active,
        })}
        ref={ref}
        type="button"
        role="button"
        title={tooltip}
        onClick={onClick}
        disabled={isDisabled}
        data-e2e={e2e}
      >
        <i className="icon">{icon}</i>
      </button>
    );
  },
);
